import { useState } from "react";
import usePageContent from '../utils/usePageContent';

const categories = [
    {
        title: "Photography",
        items: ["Product", "E-commerce", "Food", "Workshops & Training"],
    },
    {
        title: "Design",
        items: [
            "Brand Identity",
            "Retail Space Design",
            "Social Media Assets",
            "UI/UX & Web Design",
            "Marketing Consultancy",
        ],
    },
];

// Updated image paths
const imageMap = {
    Product: [
        "/images/portfolio-images/portfolio5.jpg",
        "/images/portfolio-images/portfolio15.jpg",
        "/images/portfolio-images/portfolio7.jpg",
    ],
    "E-commerce": [
        "/images/portfolio-images/portfolio6.jpg",
        "/images/portfolio-images/portfolio4.jpg",
    ],
    Food: [
        "/images/portfolio-images/portfolio12.jpg",
        "/images/portfolio-images/portfolio14.jpg",
    ],
    "Workshops & Training": [
        "/images/portfolio-images/portfolio18.jpg",
    ],
    "Brand Identity": [
        "/images/portfolio-images/portfolio7.jpg",
        "/images/portfolio-images/portfolio15.jpg",
    ],
    "Retail Space Design": [
        "/images/portfolio-images/portfolio6.jpg",
        "/images/portfolio-images/portfolio12.jpg",
    ],
    "Social Media Assets": [
        "/images/portfolio-images/portfolio14.jpg",
    ],
    "UI/UX & Web Design": [
        "/images/portfolio-images/portfolio4.jpg",
    ],
    "Marketing Consultancy": [
        "/images/portfolio-images/portfolio18.jpg",
    ],
};

const Portfolio = () => {
    const [selectedItem, setSelectedItem] = useState("Product");
    const { title, description } = usePageContent('portfolio');

    const images = imageMap[selectedItem] || [];

    return (
        <div>
            {/* Hero Section */}
            <div
                className="relative w-full h-[700px] bg-cover bg-center bg-gray-200 rounded-b-lg overflow-hidden"
                style={{
                    backgroundImage: `url(/images/portfolio-images/portfolio8.png)`,
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
                    <div className="text-center text-white px-4 md:px-8">
                        <h2 className="text-4xl md:text-5xl font-bold mb-6 inline-block relative after:content-[''] after:block after:w-full after:h-1 after:bg-red-700 after:mt-2">
                            {title}
                        </h2>
                        <p className="text-xl md:text-2xl max-w-2xl mx-auto">
                            {description}
                        </p>
                    </div>
                </div>
            </div>

            {/* Portfolio Menu + Grid */}
            <div className="flex bg-[#1a1a1a] text-white p-4 gap-8">
                {/* Left Menu */}
                <div className="w-64">
                    {categories.map((section, i) => (
                        <div key={i} className="mb-4">
                            <div className="bg-black px-4 py-2 font-bold rounded-t">
                                {section.title}
                            </div>
                            <div className="bg-white rounded-b overflow-hidden">
                                {section.items.map((item, j) => (
                                    <div
                                        key={j}
                                        onClick={() => setSelectedItem(item)}
                                        className={`px-4 py-2 cursor-pointer border-b last:border-none ${selectedItem === item
                                            ? "text-red-600 font-semibold"
                                            : "text-black"
                                            }`}
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Right Grid */}
                <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {images.map((src, idx) => (
                        <div
                            key={idx}
                            className="relative overflow-hidden h-[500px] rounded-3xl shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:z-10"
                        >
                            <img
                                src={src}
                                alt={`Portfolio ${idx}`}
                                className="w-full h-full object-cover rounded-3xl transition-all duration-300 ease-in-out opacity-40 hover:opacity-100"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Portfolio;
